import { render, staticRenderFns } from "./UserAccountBillingHistory.vue?vue&type=template&id=3bf6faf6&"
import script from "./UserAccountBillingHistory.vue?vue&type=script&lang=js&"
export * from "./UserAccountBillingHistory.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountBillingHistory.vue?vue&type=style&index=0&id=3bf6faf6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports